<!-- eslint-disable -->
<template lang="pug">
    cs-loader(v-if="!params")
    .settings__form(v-else)
        .settings__field
            label.settings__label
                | {{ $i18n.t('trainer.trainer_gameFormSetting_combiningNumOfDigits') }}
            .settings__field-body
                cs-checkbox.settings__button(
                    v-model="params.combining",
                    :checked='params.combining',
                    @change='combiningHandler',
                    :disabled='combiningDisabled'
                )
        .settings__field(v-if="params.combining && !params.roundNumbers && !params.fractions")
            .settings__field-body
                combining-digit-capacity(
                    inner-component-name="settings-tab",
                    :filtered-combining-digit-capacities='filteredCombiningDigitCapacities',
                    :combining-digit-capacities='params.combiningDigitCapacities',
                    :combining-digit-capacity-labels='combiningDigitCapacityLabels',
                    @changeCombiningDigitCapacities='changeCombiningDigitCapacities'
                )
        .settings__field
            label.settings__label
                | {{ $i18n.t('trainer.trainer_gameFormSetting_complication') }}
            .settings__field-body
                cs-spin-input(
                    v-if="slug === 'AnzanWithTime'"
                    width="xxx-large",
                    type="text",
                    :value="`${$i18n.t('trainer.trainer_gameFormSetting_speed')}: ${params.speed}с`",
                    :max="`${$i18n.t('trainer.trainer_gameFormSetting_speed')}: ${seconds[seconds.length - 1]}с`",
                    :min="`${$i18n.t('trainer.trainer_gameFormSetting_speed')}: ${seconds[0]}с`",
                    @increase="increaseSpeed",
                    @decrease="decreaseSpeed",
                )
                cs-spin-input.settings__space-between-elements(
                    width="xxx-large"
                    type="text",
                    :value="`${$i18n.t('trainer.trainer_gameFormSetting_actions')}: ${params.amountOfActions}`",
                    :max="`${$i18n.t('trainer.trainer_gameFormSetting_actions')}: ${amountsOfActions[amountsOfActions.length - 1]}`",
                    :min="`${$i18n.t('trainer.trainer_gameFormSetting_actions')}: ${amountsOfActions[0]}`",
                    @increase="increaseAmountOfActions",
                    @decrease="decreaseAmountOfActions",
                )
        .settings__field
            .settings__field-body
                settings-tab.settings__button(
                    @click.native.prevent='params.mirror = !params.mirror',
                    :selected="params.mirror",
                    :disabled="(params.difficult === 1 || params.fractions || params.roundNumbers)"
                )
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_mirror') }}
                settings-tab.settings__button(
                    @click.native.prevent='roundNumbersHandler',
                    :selected="params.roundNumbers",
                    :disabled="(params.difficult === 1 || params.fractions || params.mirror)"
                )
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_roundNumbers') }}
</template>

<script>
    /*eslint-disable*/
    import combiningCapacitiesMixin from '../../games/utils/combiningCapacitiesMixin';
    import CombiningDigitCapacity from '../../games/shared/CombiningDigitCapacity.vue';
    import AddSubConfig from "../configs/AddSubConfig";

    export default {
        mixins: [combiningCapacitiesMixin],
        props: {
            currentUserParams: {
                type: Object,
                default () {
                    return null;
                }
            },
            slug: {
                type: String,
                default: 'Anzan'
            }
        },
        data () {
            return {
                params: null,
                seconds: AddSubConfig.seconds,
                currentSpeedIndex: 0,
                amountsOfActions: [...Array(101).keys()].slice(2),
            }
        },
        watch: {
            currentUserParams: {
                handler (value) {
                    this.params = value;
                    this.currentSpeedIndex = this.seconds.indexOf(this.params.speed);
                }
            },
            'params.mirror' (val) {
                if (val) {
                    this.params.jumpOver = null;
                }
            },
        },
        methods: {
            increaseSpeed () {
                this.currentSpeedIndex += 1;
                this.params.speed = this.seconds[this.currentSpeedIndex];
            },
            decreaseSpeed () {
                this.currentSpeedIndex -= 1;
                this.params.speed = this.seconds[this.currentSpeedIndex];
            },
            increaseAmountOfActions () {
                this.params.amountOfActions += 1;
            },
            decreaseAmountOfActions () {
                this.params.amountOfActions -= 1;
            },
            roundNumbersHandler () {
                this.params.roundNumbers = !this.params.roundNumbers;
                if (this.params.roundNumbers) {
                    this.params.jumpOver = null;
                }
                if (this.params.combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
            combiningHandler (combining) {
                this.params.combining = combining;
                if (combining) {
                    this.params.jumpOver = null;
                }
                this.params.combiningDigitCapacities = [];
                if (combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
        },
        computed: {
            combiningDisabled () {
                return this.params &&
                        (
                                (this.params.difficult === 'Однозначные цифры' || this.params.mirror)
                                ||
                                (this.params.difficult === 'Двузначные цифры' && this.params.roundNumbers)
                        );
            },
        },
        components: {
            CombiningDigitCapacity,
        }
    }
</script>

<style scoped lang="scss">
    .settings__form {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        padding: 25px 40px 15px;
        @include media($xl) {
            padding: 25px 40px;
        }
    }
    .settings__field {
        display: flex;
        justify-content: flex-start;
        @include stack-space($space-base);
    }
    .settings__label {
        display: flex;
        align-items: center;
        font-weight: 500;
        margin-right: 20px;
        white-space: nowrap;
    }
    .settings__field-body {
        display: flex;
        align-items: center;
    }
    .settings__button {
        margin-right: 10px;
    }
    .settings__space-between-elements {
        margin-left: 10px;
    }
    .settings__multiselect {
        width: 160px !important;
    }
</style>
